import * as React from "react";
import { SVGProps, memo } from "react";

const SvgGreenMap = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m12.696 5.668 4.28-2.39a.7.7 0 0 1 1.042.61v10.518a1 1 0 0 1-.512.873l-4.329 2.417c-.315.176-.673.118-.914.042a1.028 1.028 0 0 1-.179-.067l-4.763-2.292-3.852 2.151a1 1 0 0 1-1.488-.873V6.651a1 1 0 0 1 .513-.873l4.477-2.5c.428-.24.947.077 1.03.131l4.695 2.26Zm-.709 10.292-3.969-1.91V5.082l3.97 1.91v8.968Zm1.53-9.033 3.001-1.675v8.86l-3 1.676V6.927Zm-10.036.017v8.861l3.031-1.692V5.252l-3.03 1.692Z"
      fill="#2BA168"
    />
  </svg>
);

const Memo = memo(SvgGreenMap);

export default Memo;
